import Raven from 'raven-js';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { UsageTrackerUtils, IframeUtils } from 'feature-unboxing-common';
import { startSignupInIframe, startSignupInPopup } from '../utils/signupUtils';
import { storeState } from '../utils/unboxingClient';
import useChat from './useChatSlice';
const {
  TrackerActions
} = UsageTrackerUtils;
export function useSignup(setIsLoading) {
  const {
    chat
  } = useChat();
  const location = useLocation();
  const query = useMemo(() => Object.fromEntries(new URLSearchParams(location.search)), [location.search]);
  const uuid = query.uuid;
  const dispatch = useDispatch();
  async function signup() {
    let id;
    if (setIsLoading) setIsLoading(true);
    try {
      id = (await storeState(chat)).id;
    } catch (e) {
      Raven.captureException(e);
    }
    dispatch(TrackerActions.trackInteraction({
      action: 'start-signup'
    }));
    if (IframeUtils.isInIframe()) {
      startSignupInIframe(id, uuid, chat, query);
    } else {
      startSignupInPopup(id, chat, query);
    }
  }
  return {
    signup
  };
}